import React from 'react';
const ArrowIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.16504 3V13.33"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.33 8.16498L8.165 13.33L3 8.16498"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArrowIcon;
